import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { MEDIA_TEXT_BASE_CLASSNAME } from './Constants';
import { createMediaText } from './MediaText';
createComponents(".".concat(MEDIA_TEXT_BASE_CLASSNAME), createMediaText, NO_PATTERN_BUSINESS_LOGIC);
